/* eslint-disable eslint-comments/disable-enable-pair, import/max-dependencies, import/no-unassigned-import  */
import React from 'react';
import ReactDOM from 'react-dom';
import {
  getCLS, getFID, getLCP, getFCP, getTTFB
} from 'web-vitals';
import Cookies from 'js-cookie';

import createAdoAds from 'src/api/createAdoAds';
import createPingdomRum from 'src/api/createPingdomRum';
import tracker from 'src/api/tracker';

import App from 'src/app/App';

import { GATEWAY, TIMEOUT } from 'config';

import 'src/images/slider/slide1_bg_x1.jpg';
import 'src/images/slider/slide1_bg_x2.jpg';
import 'src/images/slider/slide2_bg_x1.jpg';
import 'src/images/slider/slide2_bg_x2.jpg';
import 'src/images/slider/slide3_bg_x1.jpg';
import 'src/images/slider/slide3_bg_x2.jpg';
import 'src/images/autopromo/autopromo_baner_mobile_1x.jpg';
import 'src/images/autopromo/autopromo_baner_mobile_2x.jpg';
import 'src/images/autopromo/autopromo_baner_mobile_3x.jpg';
import 'src/images/autopromo/autopromo_baner_desktop_1x.jpg';
import 'src/images/autopromo/autopromo_baner_desktop_2x.jpg';
import 'src/images/recommendations/agreement_missing.jpg';
import 'src/images/recommendations/empty_listing.jpg';


import bootstrapFragmentSlider from '@grupa-pracuj/kansas-fragment-slider';
import bootstrapFragmentSearch from '@grupa-pracuj/kansas-fragment-search';
import bootstrapFragmentSeoBox from '@grupa-pracuj/kansas-fragment-seo-box';
import bootstrapFragmentTools from '@grupa-pracuj/kansas-fragment-tools';
import bootstrapFragmentAutopromo from '@grupa-pracuj/kansas-fragment-autopromo';
import bootstrapFragmentAdvices from '@grupa-pracuj/kansas-fragment-advices';
import bootstrapFragmentJobAlerts from '@grupa-pracuj/kansas-fragment-job-alerts';
import bootstrapFragmentDailySpecials from '@grupa-pracuj/kansas-fragment-daily-specials';
import bootstrapFragmentRecommendations from '@grupa-pracuj/kansas-fragment-recommendations';


const adCookieName = 'gpc_ad';
if (Cookies.get(adCookieName) === '1') {
  createAdoAds(window, window.document);
}
createPingdomRum();

const sendWebvitals = (report) => {
  tracker('send', 'webvitals', {
    name: report.name,
    value: report.value,
    delta: report.delta,
    id: report.id
  });
};

getCLS(sendWebvitals);
getFID(sendWebvitals);
getFCP(sendWebvitals);
getLCP(sendWebvitals);
getTTFB(sendWebvitals);

const advertContainer = document.querySelectorAll('.grid__advert')[0];
if (advertContainer) {
  advertContainer.classList.add('grid__advert--show-mobile');
}

bootstrapFragmentSlider({
  libraryName: 'fragment-slider',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});
bootstrapFragmentSearch({
  libraryName: 'fragment-search',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});
bootstrapFragmentSeoBox({
  libraryName: 'fragment-seo-box-categories'
});
bootstrapFragmentSeoBox({
  libraryName: 'fragment-seo-box-cities'
});
bootstrapFragmentSeoBox({
  libraryName: 'fragment-seo-box-searches'
});
bootstrapFragmentTools({
  libraryName: 'fragment-tools'
});
bootstrapFragmentAutopromo({
  libraryName: 'fragment-autopromo'
});
bootstrapFragmentAdvices({
  libraryName: 'fragment-advices',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});
bootstrapFragmentJobAlerts({
  libraryName: 'fragment-job-alerts',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});
bootstrapFragmentDailySpecials({
  libraryName: 'fragment-daily-specials',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});
bootstrapFragmentRecommendations({
  libraryName: 'fragment-recommendations',
  baseURL: GATEWAY,
  timeout: TIMEOUT
});

const root = document.querySelector('#home-page-react');
ReactDOM.render(<App />, root);

if (module.hot) {
  module.hot.accept();
}
